export const SUBJECT_ACTIONS = {
  SET_STATE: "subject/setState",
  GET_SUBJECT: "subject/getSubject",
  GET_SUBJECT_BY_ID: "subject/getSubjectById",
  CREATE_SUBJECT: "subject/createSubject",
  UPDATE_SUBJECT: "subject/updateSubject",
  DELETE_SUBJECT: "subject/deleteSubject",
};
